import { mapState } from 'vuex';
import split from 'lodash/split';
import join from 'lodash/join';
export default {
  name: 'CoreN1Tags',
  props: {
    tags: {
      type: String,
      required: false,
      default: null
    },
    tagLabel: {
      type: String,
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: function () {
    return {
      lclObject: [],
      tagItems: []
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'color'])
  },
  mounted() {
    if (this.tags) {
      this.lclObject = split(this.tags, ',', 100);
    }
  },
  methods: {
    process() {
      let tstr = {};
      tstr = join(this.lclObject, ', ');
      this.$emit('process', tstr);
    },
    remove(item) {
      this.lclObject.splice(this.lclObject.indexOf(item), 1);
      this.lclObject = [...this.lclObject];
      this.process();
    }
  }
};